import { CustomMenu } from './CustomMenu';
import AddContactModal from './AddContactModal';
export const AddContactMenu = (props, callbacks = {}) =>
  CustomMenu(
    props,
    AddContactModal,
    {
      defaultContact: props.selectProps.inputValue,
      afterContactAdded: callbacks.onContactAdded || (() => {}),
    },
    '+ Add Contact'
  );
